/* eslint-disable */

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { Formik } from 'formik';
import {
  Box,
  Button,
  IconButton,
  Container,
  Card,
  CardContent,
  TextField,
  FormControl,
  OutlinedInput,
  FormHelperText,
  InputLabel,
  InputAdornment,
  Typography,
  Tooltip,
  Alert,
  Grid
} from '@mui/material';
import { Visibility, VisibilityOff, Info } from '@mui/icons-material';
import AuthServices from '../services/auth';
import PasswordStrengthBar from 'react-password-strength-bar';

const ResetPassword = () => {
  const navigate = useNavigate();
  const [alertType, setAlertState] = useState('');
  const [apiMessage, setMessageState] = useState('');
  var query = window.location.search.substring(1);

  const [valuesPassword, setValuesPassword] = useState({
    showPassword: false
  });

  const handleClickShowPassword = () => {
    setValuesPassword({ ...valuesPassword, showPassword: !valuesPassword.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const checkPassword = () => {
    let _password = document.querySelector('input[name="password"]');
    let _passwordParent = document.querySelector('div.password_container');
    let _hintLabel = document.querySelectorAll('label')[1];
    let _hintText = document.getElementById('password_regex');
    _hintText.style.display = 'none';
    let _parentClasses = _passwordParent.classList;
    _parentClasses.remove('Mui-error');
    _hintLabel.classList.remove('Mui-error');
    var _passwordRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");

    if (_password.value != '') {
      if (_passwordRegex.test(_password.value)) {
        _parentClasses.remove('Mui-error');
        _hintLabel.classList.remove('Mui-error');
        _hintText.style.display = 'none';
      } else {
        _parentClasses.add('Mui-error');
        _hintLabel.classList.add('Mui-error');
        _hintText.style.display = 'block';
      }
    }
  };

  const defaultPasswordScoreWords = 'Too short';
  const passwordScoreWords = ['Weak', 'Okay', 'Better', 'Good', 'Strong'];

  return (
    <>
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
        style={{ minHeight: '100vh' }}
      >
        <Grid item xs={3}>
          <Grid
            container
            spacing={2}
            direction="row"
            alignItems="center"
            justifyContent="center"
            style={{ minHeight: '100vh' }}
          >
            <Grid item xs={12} md={6} className='logoContainer'
              textAlign="center">
              <img src='/logo_black.png' alt="iCapital" className='logo' />
            </Grid>
            <Grid item xs={11} md={6} className='displayBoxBorder'>
              <Box style={{ width: 'auto', margin: '20px' }}>
                {apiMessage != '' &&
                  <Box mb={3}>
                    <Alert severity={alertType}>
                      {apiMessage}
                    </Alert>
                  </Box>
                }
                <Box mb={4}>
                  <Typography
                    color="primary"
                    variant="h4"
                    align="center"
                  >
                    <b>Reset Password</b>
                  </Typography>
                </Box>
                <Typography color="textSecondary" gutterBottom>
                  <Box>{'We have sent you One Time Password (OTP) to your email address.'}</Box>
                </Typography>
                <Typography align="center" gutterBottom>
                  <Box
                    display="flex"
                    flexDirection="row"
                    position="relative"
                    justifyContent="center"
                  >
                    {'Did not receive the OTP?'} {' '}
                    <Tooltip
                      sx={{ marginLeft: "5px" }}
                      placement="bottom"
                      title={'Please check your Junk/Spam/Promotions inbox if you did not receive the OTP in your primary inbox.'}>
                      <Info />
                    </Tooltip>
                  </Box>
                </Typography>
                <Formik
                  initialValues={{
                    token: '',
                    password: ''
                  }}
                  validationSchema={Yup.object().shape({
                    token: Yup.string().max(255).required('One Time Password is required'),
                    password: Yup.string().max(50).required('New password is required')
                  })}
                  onSubmit={async (data) => {
                    setAlertState('');
                    setMessageState('');
                    try {
                      var response = await AuthServices.resetPasswordConfirm(data);
                      let success = response.data.status;
                      document.getElementsByTagName('form')[0].reset();
                      setAlertState('success');
                      setMessageState(`${success}. ` + 'Please login with your new password to continue.');
                      setTimeout(() => {
                        navigate('/?' + query, { replace: true });
                      }, 2000);
                    } catch (e) {
                      let error = e.response.data.status;
                      setAlertState('error');
                      setMessageState(error);
                    }
                  }}
                >
                  {({
                    errors,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    isSubmitting,
                    touched,
                    values
                  }) => (
                    <form onSubmit={handleSubmit}>
                      <TextField
                        error={Boolean(touched.token && errors.token)}
                        fullWidth
                        helperText={touched.token && errors.token}
                        label={'One Time Password'}
                        margin="normal"
                        name="token"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        variant="outlined"
                      />
                      <FormControl
                        fullWidth
                        margin="normal"
                        variant="outlined"
                      >
                        <InputLabel
                          className={(touched.password && errors.password) ? "Mui-error" : ""}
                          htmlFor="outlined-adornment-password"
                        >
                          {'New password'}
                        </InputLabel>
                        <OutlinedInput
                          error={Boolean(touched.password && errors.password)}
                          id="outlined-adornment-password"
                          type={valuesPassword.showPassword ? 'text' : 'password'}
                          name="password"
                          className="password_container"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          onKeyUp={checkPassword}
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                edge="end"
                                size="large">
                                {valuesPassword.showPassword ? <Visibility /> : <VisibilityOff />}
                              </IconButton>
                            </InputAdornment>
                          }
                          label={'New password'}
                          aria-describedby="password-helper-text"
                        />
                        <p id="password_regex" className="Mui-error">{'New password should be 8 characters long alphanumeric with UPPERCASE, lowercase and at least one of the following special characters !@#$%^&*'}</p>
                        {(touched.password && errors.password) && <FormHelperText
                          className={(touched.password && errors.password) ? "Mui-error" : ""}
                          id="password-helper-text"
                        >
                          {'New password is required'}
                        </FormHelperText>}
                      </FormControl>
                      <PasswordStrengthBar shortScoreWord={defaultPasswordScoreWords} scoreWords={passwordScoreWords} password={values.password} />
                      <Box my={2}>
                        <Button
                          color="primary"
                          disabled={isSubmitting}
                          fullWidth
                          size="large"
                          type="submit"
                          variant="contained"
                        >
                          {'Confirm'}
                        </Button>
                      </Box>
                    </form>
                  )}
                </Formik>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default ResetPassword;
